import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const I: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.I');

    return (
        <section
            id="rapid-mag-I"
            className={`rapid-mag-I ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-I'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1762514901345-w1cwjf-compressed-Frame%201000009213.jpg"
                        pad="https://websiteoss.ecoflow.com/figma-uploads/1762514901345-w1cwjf-compressed-Frame%201000009213.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1762858282846/20251111-184527.jpg"
                    />
                </div>
            </div>
        </section>
    );
};
export default I;
